import { render, staticRenderFns } from "./property-dashboard.vue?vue&type=template&id=5b62cbca&scoped=true&"
import script from "./property-dashboard.vue?vue&type=script&lang=js&"
export * from "./property-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./property-dashboard.vue?vue&type=style&index=0&id=5b62cbca&scoped=true&lang=css&"
import style1 from "./property-dashboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b62cbca",
  null
  
)

export default component.exports